// upcoming IDOs

export const IDO_LIST = [
  {
    idoURL: 'wasder',
    logo: '/images/idos/wasder-logo.png',
    tierName: '-', // if no tier, leave blank
    tierLogo: null, // if you include this image, it will override the tierName
    launchDate: new Date('May 06, 2021 21:00:00'),
    endDate: new Date('May 06, 2021 21:00:00'),
    totalRaise: '$150,000',
    allocationMin: 'TBD',
    allocationMax: 'TBD',
    allocationCurrency: 'USDT',
    description: 'Wasder - Find friends, join communities, and share content. Wasder brings old and new friends together around your passion for gaming. The Wasder IDO token sale will be May 06, 2021 on 0.exchange. If you received a whitelist allocation, please KYC above to be approved for the IDO.',
    distributionDate: new Date('May 06, 2021 21:00:00'),
    allocationWinningAmount: '$150',
    disclaimer: `Restricted countries for Wasder - Afghanistan, Albania, US, Botswana, Cambodia, Cuba, Ghana, Iran, Iraq, Jamaica, Korea, Libya, Mauritius, Myanmar, Nicaragua, Panama, Pakistan, South Sudan, North Sudan, Syria, Crimea, Trinidad and Tobago, Uganda, Vanuatu, Yemen, Zimbabwe, Jurisdictions in which participation or ownership of tokens is prohibited by an applicable law AND-OR jurisdictions which are subject to United States of America, United Nations, or other applicable sanctions or embargoes. If you are from a restricted country, but won an allocation, your allocation will be automatically by our market maker as part of our ZeroID offering. You will be able to claim your allocation at a later time.`,
    buttonSectionEnabled: true,
    whiteListUrl: 'https://docs.google.com/spreadsheets/d/16N4S_VqEfN04hfsfz4SIqZdH-jGqyJynCfZ6bjMBhaE/edit?usp=sharing',
    socials: [
      {
        type: 'TELEGRAM',
        url: 'https://t.me/WasderOfficial'
      },
      {
        type: 'WEBSITE',
        url: 'https://wasder.gg/'
      },
    ]
  },
  {
    idoURL: 'wise',
    logo: '/images/idos/wise-logo-text.png',
    tierName: '', // if no tier, leave blank
    tierLogo: null, // if you include this image, it will override the tierName
    launchDate: new Date('May 10, 2021 15:00:00'),
    endDate: new Date('May 11, 2021 21:00:00'),
    totalRaise: 'uncapped',
    allocationMin: 'uncapped',
    allocationMax: 'uncapped',
    allocationCurrency: 'BNB',
    description: 'Wise token is setting a new, ethical standard for DeFi. It is a fairly launched, fairly distributed, fully decentralized, audited, crypto-backed, and highly liquid asset',
    distributionDate: new Date('May 11, 2021 15:00:00'),
    allocationWinningAmount: 'n/a',
    buttonSectionEnabled: false,
    whiteListUrl: '',
    socials: [
      {
        type: 'TELEGRAM',
        url: 'https://t.me/WiseToken'
      },
      {
        type: 'WEBSITE',
        url: 'https://wisetoken.net/'
      },
    ]
  },
  {
    idoURL: 'grow',
    logo: '/images/idos/grow-logo.svg',
    tierName: '', // if no tier, leave blank
    tierLogo: null, // if you include this image, it will override the tierName
    launchDate: new Date('May 28, 2021 6:00:00'),
    // endDate: new Date('June 01, 2021 13:00:00'),
    endDate: new Date(1622457706780),
    totalRaise: 'TBD',
    allocationMin: 'TBD',
    allocationMax: 'TBD',
    allocationCurrency: 'BUSD',
    description: `GROW Token is the portal to enable operation of equitable medicinal cannabis cultivation through decentralized sharing.
Users will be able to interact with the platform to claim cultivation rewards, access their prescriptions, pay
for Grow products and earn loyalty benefits.`,
    distributionDate: new Date('June 01, 2021 13:00:00'),
    allocationWinningAmount: '$200',
    buttonSectionEnabled: true,
    whiteListUrl: 'https://docs.google.com/spreadsheets/d/1v1By-TTQxs-sBHcyOh3LV_u5SqFSm5h3732pAioE_Vo/edit?usp=sharing',
    kycURL: `https://verify-with.blockpass.org/?clientId=GROW_IDO_KYC&serviceName=IDO%20KYC&env=prod`,
    socials: [
      {
        type: 'TELEGRAM',
        url: 'https://t.me/GROWCommunity'
      },
      {
        type: 'WEBSITE',
        url: 'https://grow.house/'
      },
      {
        type: 'MEDIUM',
        url: 'https://grow-official.medium.com/'
      },
    ]
  }
]
